<ng-container *ngIf="options$ | async as options">
    <mat-form-field class="select">
        <mat-label>{{ label | titlecase }}</mat-label>
        <input
            #autocompleteInput
            type="text"
            matInput
            [disabled]="options.disabled"
            [matAutocomplete]="auto"
            [(ngModel)]="current"
            (keyup)="onAutocompleteKeyUp(autocompleteInput.value)"
            (change)="onOptionChange($event)"
        />
        <mat-icon class="autocomplete-icon" matSuffix>arrow_drop_down</mat-icon>
        <mat-hint class="hint">
            <div *ngIf="options.loading; else counterTemplate" class="loading">
                <mat-spinner diameter="15" strokeWidth="1"></mat-spinner>
                <span>loading {{ label }}</span>
            </div>
            <ng-template #counterTemplate>
                <span>{{ options.value.length }} {{ label }} loaded.</span>
            </ng-template>
        </mat-hint>
        <mat-autocomplete
            #auto="matAutocomplete"
            autoActiveFirstOption
            [displayWith]="getOptionLabel"
            (optionSelected)="onOptionSelectionChange($event)"
        >
            <mat-option
                *ngFor="let option of filteredList$ | async"
                [value]="option"
                matTooltipPosition="after"
            >
                {{ option.label }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
</ng-container>
